var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00392 0C10.4892 0 12.5039 2.01472 12.5039 4.5V5.25H15.5039V6.75H14.6287L14.0612 13.5623C14.0288 13.951 13.7038 14.25 13.3138 14.25H2.69401C2.30394 14.25 1.97899 13.951 1.9466 13.5623L1.37841 6.75H0.503906V5.25H3.50391V4.5C3.50391 2.01472 5.51862 0 8.00392 0ZM13.1234 6.75H2.88366L3.38391 12.75H12.6232L13.1234 6.75ZM8.75392 8.25V11.25H7.25392V8.25H8.75392ZM5.75391 8.25V11.25H4.25391V8.25H5.75391ZM11.7539 8.25V11.25H10.2539V8.25H11.7539ZM8.00392 1.5C6.39726 1.5 5.0856 2.76298 5.00758 4.35027L5.00391 4.5V5.25H11.0039V4.5C11.0039 2.89335 9.74092 1.58169 8.15362 1.50367L8.00392 1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket-icon.bbb08fbfb147db4121726f9efbbac2c9.svg";
export { ForwardRef as ReactComponent };